import { noOpStrategy } from './noOpStrategy';
var makeStorageProxy = function (storage) {
    return {
        getItem: function (keyName) {
            return storage.getItem(keyName);
        },
        getAllItems: function () {
            return storage;
        },
        setItem: function (keyName, keyValue) {
            storage.setItem(keyName, keyValue);
        },
        removeItem: function (keyName) {
            storage.removeItem(keyName);
        },
        clear: function () {
            storage.clear();
        },
        get length() {
            return storage.length;
        },
    };
};
export var storageFactory = function (name, resolver) {
    var storage = resolver();
    return {
        name: name,
        isSupported: function () {
            if (storage === undefined)
                return false;
            try {
                var proxy = makeStorageProxy(storage);
                var testKey = '__some_random_key_you_are_not_going_to_use__';
                proxy.setItem(testKey, testKey);
                proxy.removeItem(testKey);
                return true;
            }
            catch (e) {
                return false;
            }
        },
        storageInstance: storage
            ? function () { return makeStorageProxy(storage); }
            : noOpStrategy.storageInstance,
    };
};
export var getWindow = function () {
    if (typeof window === 'undefined')
        return undefined;
    return window;
};
